import React from "react";

const Text = ({ value }) => {
	return (
		<p className="mt-2 text-gray-800 leading-relaxed">
			{value}
		</p>
	);
};

export default Text;